// Constant data from Tl namespace. It could be static data.

export const REJECT_REASON = {
  CANNOT_VERIFY_AUTHENTICITY : 'cannot_verify_authenticity',
  WORN_OUT                   : 'worn_out',
  NO_BRAND                   : 'no_brand',
  OUT_OF_CATEGORY            : 'out_of_category',
  OUT_OF_BRAND               : 'out_of_brand',
  REQUESTED_TO_RETURN        : 'requested_to_return',
  STAIN                      : 'stain',
  TORN                       : 'torn',
  EXPIRED                    : 'expired',
  REPETITIVE                 : 'repetitive',
  BASIC_WEAR                 : 'basic_wear',
  ALTERED                    : 'altered',
  USED_SPORTWEAR             : 'used_sportwear',
  NOT_WOMEN_WEAR             : 'not_women_wear',
  OUT_OF_PRICE_RANGE         : 'out_of_price_range',
  SAMPLE_ITEM                : 'sample_item',
  BUTTON_MISSING             : 'button_missing',
  SKIN_PEELING_OFF           : 'skin_peeling_off',
  ORNAMENT_IS_MISSING        : 'ornament_is_missing',
  AUTHENTICITY               : 'authenticity',
  BROKEN                     : 'broken',
  SCRATCH                    : 'scratch',
  NON_LUXURY                 : 'non_luxury'
}
